/* PostHog, loaded in index.html: the same project as offstage.cloud, so a
   visitor's path from the site to a first key is one funnel. Named events
   and paths only. No autocapture or replays, because the console shows API
   keys, and no query or fragment on a pageview, because /verify's carries a
   live token. Every call is a no-op when the script was blocked. */

interface PostHog {
  capture(event: string, properties?: Record<string, unknown>): void;
  identify(distinctId: string, properties?: Record<string, unknown>): void;
  reset(): void;
}

declare global {
  interface Window {
    posthog?: PostHog;
  }
}

function call(fn: (posthog: PostHog) => void) {
  try {
    if (window.posthog) fn(window.posthog);
  } catch {
    // analytics never breaks the console
  }
}

export function track(event: string, properties?: Record<string, unknown>) {
  call((posthog) => posthog.capture(event, properties));
}

/** Ties this browser's events to the account, keyed by email like the site's waitlist. */
export function identify(email: string, properties?: Record<string, unknown>) {
  call((posthog) => posthog.identify(email.toLowerCase(), { email: email.toLowerCase(), ...properties }));
}

export function pageview(pathname: string) {
  track('$pageview', { $current_url: location.origin + pathname, $pathname: pathname });
}

/** On sign-out, so the next person at this browser starts anonymous. */
export function resetAnalytics() {
  call((posthog) => posthog.reset());
}
